import { useEffect, useRef, useState } from 'react';
import { NotificationAlert, Table } from '../../../components';
import { allReviewscolumns } from './columns';
import { getAllQuarters } from '../../../services/reviewsServices';
import { AllReviewsProps } from '../../../types';

const AllReviews = () => {
  const [data, setData] = useState<AllReviewsProps[]>([]);
  const [loading, setLoading] = useState(true);
  const myRef = useRef<any>();

  useEffect(() => {
    (async () => {
      setLoading(true);
      const { data, error } = await getAllQuarters('mentor');
      setLoading(false);
      if (error) return myRef.current?.call('error', error?.message);
      if (error) return;
      if (data) {
        setData(data);
      }
    })();
  }, []);

  return (
    <div className="flex flex-col gap-y-[10px]">
      <div className="p-[10px] flex flex-col">
        <div className="text-[20px] font-[500]">All Quarterly Reviews</div>
        <div className="opacity-45">
          Effortlessly view and monitor existing quarterly review cycles,
          helping mentors stay informed about deadlines, statuses and overall
          feedback progress for themselves and their assigned mentees.
        </div>
      </div>
      <Table
        columns={allReviewscolumns}
        data={data}
        errorFetchingData={false}
        loading={loading}
        rowKey="id"
      />
      <NotificationAlert ref={myRef} />
    </div>
  );
};

export default AllReviews;
